import { generateTestId } from "@client-shared";

export const setOrdersDataTableTestId = (identifier: string): string => generateTestId("OrdersDataTable", identifier);

export const setOrdersDataTableContainerTestId = (): string => setOrdersDataTableTestId("container");
